import React, { ChangeEvent } from 'react';
import { useVesselStore } from '../../context/VesselContext';
import SelectVessel from '../ui/select-vessel/SelectVessel';
import { SelectOption } from '../../types/ViewModel/SelectOption';
import { Vessel } from '../../types/ViewModel/Vessel/Vessel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FilterButton } from '../../styles/button.style';
import { useAppStore } from '../../context/AppContext';
import { PanelSettingsButton, SelectVesselWrapper, SettingsPanelWrapper, Wrapper } from './SelectVesselHeader.styles';
import { useAolStore } from '../../context/AolContext';
import { QueryParamValueProps, useQueryParamsHandler } from 'odfjell-query-manager';
import { PanelContent, PanelSectionContent } from '../ui/odfjellPanel/OdfjellPanel.styles';
import { useStowageLayoutStore } from 'src/context/StowageLayoutContext';
import { PanelDimensions } from 'src/types/ViewModel/Stowage/PanelDimensions';
import { usePositionFromClick } from 'src/hooks/stowage/usePositionFromClick';
import OdfjellPanel, { PANEL_CONSTANTS } from '../ui/odfjellPanel/OdfjellPanel';

const SelectVesselHeader: React.FC = () => {
    const { isSettingsPanelOpen, setIsSettingsPanelOpen } = useAppStore();
    const {
        selectedVessel,
        selectedListVessel,
        vesselList,
        filteredVesselList,
        setFilteredVesselList,
        setSelectedVessel,
        setSelectedListVessel,
        includeInactiveVessels,
        setIncludeInactiveVessels,
    } = useVesselStore();
    const activeVessel = selectedVessel ?? selectedListVessel;
    const { setAolFilter, defaultAolFilter } = useAolStore();
    const { mouseClickPosition } = useStowageLayoutStore();

    const { triggerQueryParamsUpdate, getQueryParamValueFromUrl } = useQueryParamsHandler();

    const updateQuery = (vessel: Vessel) => {
        const queryParamValues: QueryParamValueProps[] = [];
        queryParamValues.push({ name: 'imoNumber', newValue: vessel.imoNumber.toString() });

        if (getQueryParamValueFromUrl('reportName')) {
            queryParamValues.push({ name: 'reportName', newValue: getQueryParamValueFromUrl('reportName') });

            if (getQueryParamValueFromUrl('reportSection')) {
                queryParamValues.push({ name: 'reportSection', newValue: getQueryParamValueFromUrl('reportSection') });
            }
        } else {
            setSelectedVessel(null);
            setSelectedListVessel(null);
        }
        setAolFilter(defaultAolFilter);
        sessionStorage.setItem('userChangedVessel', 'true');

        triggerQueryParamsUpdate(queryParamValues, 'clear-all');
    };

    const handleSelectVesselChange = (e: SelectOption) => {
        const selVessel = vesselList.find((sh) => sh.imoNumber === +e.value);
        if (selVessel) {
            updateQuery(selVessel);
        }
    };

    const toggleIncludeInactiveVessels = (event: ChangeEvent<HTMLInputElement>) => {
        setIncludeInactiveVessels(event.target.checked);
        if (event.target.checked) {
            setFilteredVesselList(vesselList);
        } else {
            setFilteredVesselList(vesselList.filter((o) => o.isActive));
        }
    };

    const isSettingsPanelActive = () => {
        return !!isSettingsPanelOpen;
    };

    const toggleSettingsPanel = () => {
        const panelOpen = !isSettingsPanelOpen;
        setIsSettingsPanelOpen(panelOpen);
    };

    const panelDimensions: PanelDimensions = {
        width: PANEL_CONSTANTS.SMALL_WIDTH,
        height: 350,
    };

    const panelPosition = usePositionFromClick(mouseClickPosition, panelDimensions);

    const onClose = () => {
        setIsSettingsPanelOpen(false);
    };

    const getSettingsPanel = () => {
        if (isSettingsPanelOpen) {
            return (
                <OdfjellPanel
                    headerTitle={'Settings'}
                    initialPosition={mouseClickPosition ? panelPosition : undefined}
                    panelWidth={PANEL_CONSTANTS.SMALL_WIDTH}
                    onCancel={onClose}
                    actionButtonText="OK"
                >
                    <PanelSectionContent>
                        <PanelContent>
                            <input type="checkbox" onChange={toggleIncludeInactiveVessels} checked={includeInactiveVessels} />
                            Include inactive vessels
                        </PanelContent>
                    </PanelSectionContent>
                </OdfjellPanel>
            );
        }
    };

    return (
        <>
            <Wrapper>
                {activeVessel && (
                    <>
                        <SelectVesselWrapper>
                            <SelectVessel
                                onChange={handleSelectVesselChange}
                                vesselList={filteredVesselList}
                                selectedVessel={activeVessel}
                                width="200px"
                                height="30px"
                            ></SelectVessel>
                            <PanelSettingsButton>
                                <FilterButton isSelected={isSettingsPanelActive()} onClick={toggleSettingsPanel} title="Click to open settings">
                                    <FontAwesomeIcon icon="cog" />
                                </FilterButton>
                            </PanelSettingsButton>
                        </SelectVesselWrapper>
                    </>
                )}
            </Wrapper>
            <SettingsPanelWrapper>{getSettingsPanel()}</SettingsPanelWrapper>
        </>
    );
};

export default SelectVesselHeader;
